export default {
  UNASSIGNED: 'UNASSIGNED',
  SENT: 'SENT',
  CONNECTED: 'CONNECTED',
} as const
